import React, { useContext, useState } from 'react';
import _ from 'lodash';
import './index.scss';
import { AuthContext } from '../../../Contexts';
import { useTranslation } from 'react-i18next';
import AuthenticateModal from '../../HomeDeliveryNew/AuthenticateModal';
import { INTELLIMIZE_LOYALTY_SIGN_UP_STARTED } from '../../../constants/defaults';
import LazyImageWithNoscript from '../../common/LazyImageWithNoscript';

export const SignupPromoBanner = ({ isFromCouponPage = false }) => {
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;
  const { t } = useTranslation();
  const [openSignupModal, setOpenSignupModal] = useState(false);

  const handleOpenSignUpModal = () => {
    setOpenSignupModal(true);
    _.triggerGTMVirtualPageViewEvent({
      event: 'drugPageBannerClick',
      loyaltySignupPath: 'Drug_page_banner'
    });
    if (isFromCouponPage) {
      _.triggerGTMVirtualPageViewEvent({
        event: 'SignUpStarted',
        loyaltySignupPath: 'Member_saves_the_most_banner'
      });
      _.sendIntellimizeEvent(INTELLIMIZE_LOYALTY_SIGN_UP_STARTED);
    }
  };

  const handleCloseSignUpModal = () => {
    setOpenSignupModal(false);
  };

  return (
    !isLoggedIn && (
      <>
        {openSignupModal && (
          <div className="mainModal afterSignupmodal">
            <div
              className="transparentBg"
              onClick={handleCloseSignUpModal}
            ></div>
            <div className="signUpModal">
              <AuthenticateModal
                hideAuthenticateModal={handleCloseSignUpModal}
              />
            </div>
          </div>
        )}
        <div
          className="signupPromoBanner"
          tabIndex="0"
          onClick={handleOpenSignUpModal}
          onKeyDown={e => {
            if (e.key === 'Enter') handleOpenSignUpModal();
          }}
        >
          <div className="innerSignupPromo">
            <LazyImageWithNoscript
              className="sc-logo"
              height={28}
              width={26.826}
              src="/content/images/icons/logo-icon.png"
              alt=""
            />
            <p>{t('Members save the most')}</p>

            <button className="signupBtn">{t('Sign up for free')}</button>
          </div>
        </div>
      </>
    )
  );
};
